#content
<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100" v-if="isLoaded">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" @Refresh="refresh" @doLoad="doLoad" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20 d-flex" style="flex-direction: row" v-if="isChartLoaded">
				<div style="width: 85%" class="mr-3">
					<sf-card class="p-0 border-0 bg-transparent">
						<chart-view class="mb-3" :scrId="scrId"></chart-view>
						<cal-form :scrId="scrId"></cal-form>
					</sf-card>
				</div>
				<div class="h-100" style="width: 14%">
					<sf-card class="p-0 border-0 bg-transparent">
						<sum-chart class="mb-3" :scrId="scrId"></sum-chart>
						<sum-form :scrId="scrId"></sum-form>
					</sf-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { serviceComputed, serviceMethods } from '@mmc/mmcm/TorqStts/store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import SearchView from './Search/Search';
import ChartView from './Table/Chart.vue';
import SumChart from './Table/SumChart.vue';
import CalForm from './Table/CalForm.vue';
import SumForm from './Table/SumForm.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false,
			isChartLoaded: false
		};
	},
	async created() {
		//MMCAD : 측정기 관리자, MMCWK: 측정기 업무처리자, MMCUR : 측정기 일반사용자, OS : 시스템 관리자
		this.setState_({ key: 'isMmcAdmin', value: await this.inclManyUsrGrp_(['MMCAD', 'MMCWK', 'OS']) });
		this.isLoaded = true;
	},
	components: { SearchView, SumChart, ChartView, CalForm, SumForm },
	methods: {
		...qmsMethods,
		...serviceMethods,
		refresh() {
			this.$refs.searchView.searchList();
		},
		doLoad() {
			this.isChartLoaded = true;
		}
	},
	computed: {
		...qmsComputed,
		...serviceComputed
	}
};
</script>

<style></style>
